/**
 * @description sets googleRecaptcha token to form
 * @param {Object} params
 * @param {String|JQuery} params.formSelector
 * @return {Promise<any>}
 */
function setToken(params) {
    var isEnabled = $("meta[name=googleRecaptchaEnabled]").attr("content") === "true";

    if (!isEnabled) {
        return Promise.resolve();
    }
    var siteKey = $("meta[name=googleRecaptchaSiteKey]").attr("content");
    var $currentForm = $(params.formSelector);
    var $tokenInput = $currentForm.find("[name='recaptcha_token']");
    var action = $tokenInput.data("action");

    return new Promise(function (resolve, reject) {
        try {
            window.grecaptcha.ready(function() {
                window.grecaptcha.execute(siteKey, { action: action })
                    .then(function(token) {

                        if (!token) {
                            reject(new Error("invalidToken"));
                        }
                        $tokenInput.val(token);
                        resolve();
                    });
            });
        } catch (error) {
            reject(error);
        }
    });
}

module.exports = {
    setToken: setToken
};
